export { default } from "ember-stereo/helpers/autoplay-allowed";
